import React, { useEffect, useRef } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { useInView } from 'react-intersection-observer'
import { useMediaQuery } from 'react-responsive'

import classNames from 'classnames'

import * as styles from './media.module.scss'

export default function Media({
  desktop,
  mobile,
  loading = 'lazy',
  className,
  full = false,
  timeStamp = 0,
}) {
  if (!desktop) {
    return (
      <p style={{ color: 'red', fontSize: '2rem' }}>
        Missing Image - {className}
      </p>
    )
  }

  if (desktop?.file.contentType === 'video/mp4') {
    return (
      <Video
        desktop={desktop}
        mobile={mobile}
        className={className}
        full={full}
        timeStamp={timeStamp}
      />
    )
  }

  if (desktop && !mobile) {
    const desktopImage = getImage(desktop)

    if (desktopImage) {
      return (
        <GatsbyImage
          className={classNames(className, { 'full-width': full })}
          image={desktopImage}
          loading={loading}
          alt={desktop.description || desktop?.file?.fileName}
        />
      )
    } else {
      // IS SVG
      return (
        <img
          src={desktop.file.url}
          alt={desktop.description}
          loading={loading}
          className={classNames(className, { 'full-width': full })}
        />
      )
    }
  }

  const desktopIsSVG = desktop?.file?.contentType === 'image/svg+xml'
  const mobileIsSVG = mobile?.file?.contentType === 'image/svg+xml'

  return (
    <picture
      className={classNames(styles.media, className, { 'full-width': full })}
    >
      {mobile && (
        <source
          media="(max-width:979px)"
          srcSet={`${mobile.file.url}${!mobileIsSVG ? '?fm=webp&q=90' : ''} ${
            mobile.file.details.image.width
          }w`}
          alt={mobile.description}
          width={mobile.file.details.image.width}
          height={mobile.file.details.image.height}
        />
      )}

      <source
        media="(max-width:980px)"
        srcSet={`${desktop.file.url}${!desktopIsSVG ? '?fm=webp&q=90' : ''} ${
          desktop.file.details.image.width
        }w`}
        alt={desktop.description}
        width={desktop.file.details.image.width}
        height={desktop.file.details.image.height}
      />

      <img
        className={classNames(styles.img, className, { 'full-width': full })}
        style={{
          '--desktop-max-width': desktop.file.details.image.width + 'px',
          '--mobile-max-width': mobile.file.details.image.width + 'px',
        }}
        src={`${desktop.file.url}${!desktopIsSVG ? '?fm=webp&q=90' : ''}`}
        alt={desktop.description}
        loading={loading}
        width={desktop.file.details.image.width}
        height={desktop.file.details.image.height}
      />
    </picture>
  )
}

const Video = ({ desktop, mobile, className, timeStamp, full }) => {
  const videoRef = useRef()
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)',
  })

  const { ref, inView } = useInView({
    initialInView: false,
    threshold: 0.5,
  })

  useEffect(() => {
    const video = videoRef.current

    if (video) {
      if (inView) {
        if (video.paused) {
          video.play()
        }
      } else {
        video.pause()
      }
    }
  }, [inView, videoRef, isDesktopOrLaptop])

  const videoSrc = isDesktopOrLaptop
    ? desktop?.file.url + `#t=${timeStamp}`
    : mobile
    ? mobile?.file.url + `#t=${timeStamp}`
    : desktop?.file.url + `#t=${timeStamp}`

  return (
    <div
      ref={ref}
      className={classNames('video-container', styles.mediaVideo, className, {
        'full-width': full,
      })}
    >
      <video ref={videoRef} src={videoSrc} muted playsInline loop />
    </div>
  )

  // return (
  //   <>
  //     <div
  //       ref={ref}
  //       className={classNames(
  //         'video-container',
  //         className,
  //         styles.mediaVideoMobile,
  //         {
  //           'full-width': full,
  //         }
  //       )}
  //     >
  //       <video
  //         src={mobile?.file.url + `#t=${timeStamp}`}
  //         muted
  //         // autoPlay
  //         playsInline
  //         loop
  //         ref={videoRef}
  //       />
  //     </div>
  //     <div
  //       ref={ref}
  //       className={classNames(
  //         'video-container',
  //         className,
  //         styles.mediaVideoDesktop,
  //         {
  //           'full-width': full,
  //         }
  //       )}
  //     >
  //       <video
  //         src={desktop?.file.url + `#t=${timeStamp}`}
  //         muted
  //         // autoPlay
  //         playsInline
  //         loop
  //         ref={videoRef}
  //       />
  //     </div>
  //   </>
  // )
}
